import { Controller } from "@hotwired/stimulus"

// Shows the dues and GL code a membership level will bill as soon as the level
// is picked, mirroring MembershipPeriod#apply_catalog_pricing. The server still
// does the writing — this only makes the numbers visible while there is a chance
// to override them, instead of blank until after save.
export default class extends Controller {
  static targets = ["level", "dues", "glCode"]
  static values = { rates: Object }

  connect() {
    // Remembers what this controller typed, so switching levels re-prices the
    // fields but a hand-keyed override is never clobbered.
    this.autofilled = {}
  }

  apply() {
    const rate = this.ratesValue[this.levelTarget.value] || {}

    this.fill("dues", this.duesTarget, rate.dues)
    this.fill("glCode", this.glCodeTarget, rate.gl_code)
  }

  fill(key, field, value) {
    if (field.value !== "" && field.value !== this.autofilled[key]) return

    field.value = value || ""
    this.autofilled[key] = field.value
  }
}
